import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { BrandMark } from "@/components/brand";
import { firmConfiguration } from "../../constans";
import { getSubdomain } from "../../helpers/helpers";
import { useGetUserDetails } from "../../hooks/useGetUserDetails";
import { lawyerSelectors } from "../../redux/lawyer/selectors";

/**
 * Sidebar header: the square CaseBlink mark in both rail states.
 * White-labelled subdomains show the firm's logo and link to the firm site.
 *
 * Deliberately not a `SidebarMenuButton`: its `[&_svg]:size-4` rule would
 * shrink the mark.
 */
export function SidebarBrand() {
  const {
    userDetails: { userType }
  } = useGetUserDetails();
  const lawyer = useSelector(lawyerSelectors.selectAll);
  const subdomain = getSubdomain();
  const firmConfig = firmConfiguration[subdomain];
  const isCaseblink = !firmConfig;

  const homePath = useMemo(() => {
    if (userType === "ForeignNational") return "/portal";
    if (userType !== "Individual") return "/cases";
    return "/";
  }, [userType]);

  const className =
    "flex h-8 w-fit items-center gap-2 rounded-md p-2 outline-hidden ring-sidebar-ring hover:bg-sidebar-accent focus-visible:ring-2 group-data-[collapsible=icon]:size-8 group-data-[collapsible=icon]:justify-center";

  const inner = isCaseblink ? (
    <BrandMark title="CaseBlink" className="size-4.5" />
  ) : lawyer.lawFirmLogo ? (
    <img
      src={lawyer.lawFirmLogo}
      alt={firmConfig.practiceName}
      className="h-5 w-auto max-w-full object-contain object-left"
    />
  ) : (
    <span className="truncate text-sm font-medium">
      {firmConfig.practiceName}
    </span>
  );

  if (firmConfig?.domainUrl) {
    return (
      <a
        href={firmConfig.domainUrl}
        target="_blank"
        rel="noreferrer"
        className={className}
        title={firmConfig.practiceName}
      >
        {inner}
      </a>
    );
  }

  return (
    <RouterLink to={homePath} className={className} title="CaseBlink">
      {inner}
    </RouterLink>
  );
}
